import { motion } from 'framer-motion'
import React from 'react'

export default function Load() {
    return (
        <div>
            <motion.div
                initial={{ opacity: 1, y: '0' }}
                animate={{ opacity: 1, y: '-200%' }}
                transition={{ ease: "easeOut", duration: 2.8, delay: 0 }}
                id="top-load"
            ></motion.div>
            <motion.div
                initial={{ opacity: 1, y: '0' }}
                animate={{ opacity: 1, y: '200%' }}
                transition={{ ease: "easeOut", duration: 2.8, delay: 0 }}
                id="bottom-load"
            ></motion.div>
        </div>
    )
}
